import React, { HTMLAttributes } from 'react';

const WarningIcon: React.FC<HTMLAttributes<HTMLSpanElement>> = (props) => {
  return (
    <span
      className={`font-semibold px-2 rounded-full text-sm text-black bg-yellow-300 ${
        props.onClick ? 'cursor-pointer' : ''
      }`}
      {...props}
    >
      !
    </span>
  );
};

export default WarningIcon;
